import request from 'utils/request'

// 获取信用表格记录
export const getTableData = data =>
  request().post('company/amount/statistics/page', data)

// 获取信用趋势
export const getTrendData = data =>
  request().post('company/amount/statistics', data)

// 下载报表
export const download = data =>
  request().post('company/amount/statistics/export', data, {
    responseType: 'blob',
  })
